export default __webpack_public_path__ + "static/media/2503283.01fba4cc.jpg";